var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWebcast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24,
    r: 24,
    fill: "white",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 18.1C33.7 17.9 33.3 17.9 33 18.1L28.6 21.1V19C28.6 17.9 27.7 17 26.6 17H16.5C15.4 17 14.5 17.9 14.5 19V29C14.5 30.1 15.4 31 16.5 31H26.5C27.6 31 28.5 30.1 28.5 29V26.9L32.9 29.9C33.1 30 33.3 30.1 33.5 30.1C33.7 30.1 33.8 30.1 34 30C34.3 29.8 34.5 29.5 34.5 29.1V19C34.5 18.6 34.3 18.3 34 18.1ZM26.5 29H16.5V19H26.5V29ZM32.5 27.1L28.5 24.4V23.5L32.5 20.8V27.1Z",
    fill: "#79747E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebcast);
export default __webpack_public_path__ + "static/media/Webcast.990b6cb8cbce854aae4a0bc5616a214a.svg";
export { ForwardRef as ReactComponent };